import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Warning, Warnings } from "../../api/observeApi";
import { fetchWarnings } from "./warningsThunks";
import { LoadingStatus } from "common/types";

export interface WarningsState {
  warnings: Warning[];
  totalRows: number;
  offset: number;
  deploymentFilter?: string;
  filters?: string;
  resultsPerPage: number;
  status: LoadingStatus;
}

const initialState: WarningsState = {
  warnings: [],
  totalRows: 0,
  offset: 0,
  resultsPerPage: 20,
  status: "idle",
};

export const listWarningsSlice = createSlice({
  name: "warnings",
  initialState,
  reducers: {
    setStatus: (state, action: PayloadAction<LoadingStatus>) => {
      state.status = action.payload;
    },
    setOffset: (state, action: PayloadAction<number>) => {
      state.offset = action.payload;
    },
    setDeploymentFilter: (state, action: PayloadAction<string>) => {
      state.deploymentFilter = action.payload;
      if (state.deploymentFilter !== "") {
        // We just filter deployments for Warnings, update this once we support other filters
        state.filters = `deployment=${action.payload}`;
      } else {
        state.filters = undefined;
      }
    },
    resetRows: (state) => {
      state.warnings = [];
    },
    resetWarningsState: () => {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchWarnings.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchWarnings.fulfilled, (state, action) => {
        state.status = "idle";
        const resp = action.payload as Warnings;
        if (action.meta.arg) {
          state.warnings = resp.results;
        } else {
          state.warnings.push(...resp.results);
        }
        if (resp.count) {
          state.totalRows = resp.count;
        } else {
          state.totalRows = 0;
        }
      })
      .addCase(fetchWarnings.rejected, (state, action) => {
        state.status = "failed";
      });
  },
});

export const {
  setStatus,
  setOffset,
  setDeploymentFilter,
  resetRows,
  resetWarningsState,
} = listWarningsSlice.actions;

export default listWarningsSlice.reducer;
